<template>
  <el-dialog
    title="数据格式"
    :visible.sync="dialogForm.visiable"
    class="small-dialog"
    v-dialogDrag
    :close-on-click-modal="false"
    @open="openDialog"
  >
    <ul class="flex border rounded-5px border-color w-400px divide-x">
      <li
        class="w-100px h-40px flex justify-center items-center border-color"
        v-for="(item, index) in tabList"
        :key="index"
        @click="changeTab(item.value)"
        :class="currentTab === item.value ? 'main-color' : ''"
      >
        {{ item.name }}
      </li>
    </ul>
    <el-form label-width="150px" :model="formData" :rules="rules" class="mt-20px" ref="form">
      <el-form-item label="样例">
        <el-input v-model="formData.example" clearable placeholder="请输入" disabled></el-input>
      </el-form-item>
      <el-form-item label="小数位数" prop="decimalPlacesToKeep" v-if="currentTab !== 1">
        <el-input v-model="formData.decimalPlacesToKeep" clearable placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="度量单位" v-if="_.includes([2, 3], currentTab)">
        <el-input v-model="formData.unit" clearable placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="货币标识" prop="currencyIdentifier" v-if="currentTab === 3">
        <el-select v-model="formData.currencyIdentifier" clearable placeholder="请选择" filterable>
          <el-option
            v-for="(item, index) in currencyList"
            :key="index"
            :label="item.label"
            :value="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="使用千分位分隔符" v-if="_.includes([2, 3], currentTab)">
        <el-checkbox v-model="formData.isThousandsSeparator"></el-checkbox>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="dialogForm.visiable = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DataFormat',
  props: {
    dialogForm: {
      type: Object,
    },
  },
  data() {
    return {
      tabList: [
        { name: '无格式', value: 1 },
        { name: '数值', value: 2 },
        { name: '货币', value: 3 },
        { name: '百分比', value: 4 },
      ],
      currentTab: 1,
      formData: {
        example: '1234',
        decimalPlacesToKeep: '2',
        unit: '', // 度量单位
        currencyIdentifier: '', // 货币标识
        isThousandsSeparator: false, // 是否使用千位分隔符
        isPercentage: false, // 是否百分比
      },
      rules: {
        decimalPlacesToKeep: [{ required: true, message: '请输入小数位数', trigger: 'blur' }],
        currencyIdentifier: [{ required: true, message: '请选择货币标识', trigger: 'change' }],
      },
      currencyList: [{ label: '¥' }, { label: '$' }, { label: '€' }, { label: '£' }],
    }
  },
  watch: {
    // 小数位数
    'formData.decimalPlacesToKeep': {
      handler(newVal) {
        if (newVal) {
          this.handleDataFormat(this.currentTab)
        }
      },
    },
    // 使用千分位分隔符
    'formData.isThousandsSeparator': {
      handler(newVal) {
        if (newVal) {
          this.formData.example = Number(this.formData.example).toLocaleString('en-US', {
            minimumFractionDigits: Number(this.formData.decimalPlacesToKeep),
          })
        } else {
          this.formData.example = this.formData.example.replace(',', '')
        }
      },
    },
  },
  methods: {
    changeTab(val) {
      this.currentTab = val
      this.handleDataFormat(val)
    },
    // 处理数据格式
    handleDataFormat(val) {
      if (val === 4) {
        // 百分比
        const value = 100
        this.formData.example = `${value.toFixed(Number(this.formData.decimalPlacesToKeep))}%`
        this.formData.unit = ''
        this.formData.currencyIdentifier = ''
        this.formData.isThousandsSeparator = false
        this.formData.isPercentage = true
      } else if (val === 1) {
        // 无格式
        this.formData.example = 1234
        this.formData.decimalPlacesToKeep = 0
        this.formData.unit = ''
        this.formData.currencyIdentifier = ''
        this.formData.isThousandsSeparator = false
        this.formData.isPercentage = false
      } else {
        // 数值、货币
        const value = 1234
        this.formData.isPercentage = false
        if (val === 2) {
          this.formData.currencyIdentifier = '' // 数值
        }
        if (this.formData.isThousandsSeparator) {
          this.formData.example = value.toLocaleString('en-US', {
            minimumFractionDigits: Number(this.formData.decimalPlacesToKeep),
          })
        } else {
          this.formData.example = value.toFixed(Number(this.formData.decimalPlacesToKeep))
        }
      }
    },
    // 保存
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('updateFormat', this.formData, this.currentTab)
          this.dialogForm.visiable = false
        }
      })
    },
    // 打开对话框
    openDialog() {
      if (!_.isEmpty(this.dialogForm.detail)) {
        this.currentTab = this.dialogForm.detail.type
        _.assign(
          this.formData,
          _.pick(this.dialogForm.detail, [
            'example',
            'currencyIdentifier',
            'decimalPlacesToKeep',
            'isPercentage',
            'isThousandsSeparator',
            'unit',
          ])
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.border-color {
  border-color: var(--systemMainColor);
}
.main-color {
  background-color: var(--systemMainColor);
  color: var(--colorLumpText);
}

</style>
